"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var $=require("react"),x=require("react-transition-group"),t=require("styled-components"),e=require("@vfuk/core-mixins");function l(n){return n&&n.__esModule?n:{default:n}}var s=l($),r=l(t);const g={animation:e.createMixin(()=>t.css`
      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    `),config:{duration:150}},M={animation:e.createMixin(()=>t.css`
      @keyframes fadeOut {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    `),config:{duration:150}},T={animation:e.createMixin(()=>t.css`
      @keyframes scaleUp {
        0% {
          transform: scale(0.9);
        }
        100% {
          transform: scale(1);
        }
      }
    `),config:{duration:150}},_={animation:e.createMixin(()=>t.css`
      @keyframes scaleDown {
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(0.25);
        }
      }
    `),config:{duration:150}},k={animation:e.createMixin(()=>t.css`
      @keyframes slideFromBottom {
        0% {
          transform: translateY(100%);
        }
        100% {
          transform: translateY(0);
        }
      }
    `),config:{duration:150}},h={animation:e.createMixin(()=>t.css`
      @keyframes slideFromLeft {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(0);
        }
      }
    `),config:{duration:150}},v={animation:e.createMixin(()=>t.css`
      @keyframes slideFromRight {
        0% {
          transform: translateX(100%);
        }
        100% {
          transform: translateX(0);
        }
      }
    `),config:{duration:150}},F={animation:e.createMixin(()=>t.css`
      @keyframes slideFromTop {
        0% {
          transform: translateY(-100%);
        }
        100% {
          transform: translateY(0);
        }
      }
    `),config:{duration:150}},X={animation:e.createMixin(()=>t.css`
      @keyframes slideToBottom {
        0% {
          transform: translateY(0);
        }
        100% {
          transform: translateY(100%);
        }
      }
    `),config:{duration:150}},Y={animation:e.createMixin(()=>t.css`
      @keyframes slideToLeft {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    `),config:{duration:150}},E={animation:e.createMixin(()=>t.css`
      @keyframes slideToRight {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(100%);
        }
      }
    `),config:{duration:150}},O={animation:e.createMixin(()=>t.css`
      @keyframes slideToTop {
        0% {
          transform: translateY(0);
        }
        100% {
          transform: translateY(-100%);
        }
      }
    `),config:{duration:150}},b={animation:e.createMixin(()=>t.css`
      @keyframes none {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 1;
        }
      }
    `),config:{duration:0}},d={fadeIn:g,fadeOut:M,scaleUp:T,scaleDown:_,slideFromBottom:k,slideFromLeft:h,slideFromRight:v,slideFromTop:F,slideToBottom:X,slideToLeft:Y,slideToRight:E,slideToTop:O,none:b},A=(n,a)=>n.duration||d[a].config.duration,D=n=>n.delay||0,c=n=>n/1e3,j=typeof r.default=="object"&&"default"in r.default?r.default.default:r.default,m=n=>{const a=n.animations.map(o=>{if(o!=="none")return d[o].animation()}),i=n.animations.map(o=>{if(o==="none")return;const p=A(n,o);return`${o} ${c(p)}s ${c(D(n))}s`}).join(", ");return t.css`
    ${a}
    animation: ${i};
  `},u=j.span(n=>t.css`
    .animation-container {
      &-enter {
        ${m(n.enter)}
        animation-fill-mode: both;
      }

      &-exit {
        ${m(n.exit)}
        animation-fill-mode: both;
      }
    }
  `);var q=Object.freeze({__proto__:null,Animate:u});const f=n=>{const a=n.duration||0,i=n.delay||0;return a+i},y=({show:n=!0,enter:a,exit:i,children:o})=>s.default.createElement(u,{enter:a,exit:i},s.default.createElement(x.CSSTransition,{in:n,timeout:{enter:f(a),exit:f(i)},onEntered:a.onDone,onExited:i.onDone,unmountOnExit:!0,mountOnEnter:!0,classNames:"animation-container"},o));exports.Animate=y;exports.AnimateStyles=q;exports.default=y;
//# sourceMappingURL=index.cjs.map
